import * as React from "react";

const CloseMenuIcon = ({color, ...rest}) => (
	<svg
		width={24}
		height={24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...rest}
	>
		<path
			d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
			stroke={color ? color : 'white'}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default CloseMenuIcon;
